<template>
  <v-menu :key="document.title" v-model="document.open" full-width offset-x>
    <template slot="activator" slot-scope="{ on }">
      <div v-ripple class="my-event" v-on="on" v-html="document.title"></div>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat class="custom-font-regular">
      <v-toolbar color="red lighten-2" dark dense>
        <v-toolbar-title v-html="document.title"></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <span class="grey--text">Subarea:</span><br>
        <pre>{{ document.subarea }}</pre>
      </v-card-text>
      <v-card-title class="pt-0">
        <div>
          <span class="grey--text">Estado:</span><br>
          <span v-html="document.statusDisplay"></span>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small flat color="primary" @click="goDetail(document)">Ver Detalle</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    document: Object,
    hide: Boolean
  },

  methods: {
    goDetail (document) {
      this.$router.push({ name: 'ficha', params: { id: document.subareaId } })
    }
  },

  watch: {
    'hide' () {
      if (this.hide) {
        this.document.open = false
      }
    }
  }
}
</script>

<style scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #df7274;
    color: #ffffff;
    border: 1px solid #df7274;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  pre {
    font-family: 'Roboto', sans-serif;
    line-height: 1.5;
  }
</style>
